import store from '@/store';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { Message } from 'element-ui';
import _ from 'lodash';
const getDictList = async () => {
    if (!dictData.saleStages) {
        const dictRes = await getDictDataApi({
            dictCodes: 'NEOCRM_SALE_STAGE_WIN'
        });
        dictData.saleStages = _.keys(dictRes.data.NEOCRM_SALE_STAGE_WIN);
    }
};
const dictData = {
    saleStages: ''
};
export const tableConfig = {
    name: 'addNewMainSearach',
    fields: [
        {
            label: '内外部业务',
            prop: 'oilIsGroupCustomer',
            type: 'select',
            visible: true,
            rule: [
                { required: true, message: '内外部业务不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'SYS_WM_IN_OR_OUT_CUSTOMER'
        },
        {
            label: '合同性质',
            prop: 'contractCharacter',
            type: 'select',
            visible: true,
            rule: [
                { required: true, message: '合同性质不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'SYS_WM_CONTRACT_CHARACTER',
            options: []
        },
        {
            label: '关联合同',
            prop: 'mainContract',
            value: 'mainContract',
            type: 'advance',
            visible: true,
            rule: [
                { required: true, message: '主合同编号不能为空', trigger: ['change', 'blur'] }
            ],
            advanceConfig: [
                { 'prop': 'contractCode', 'value': '主合同编码' },
                { 'prop': 'contractName', 'value': '主合同名称' }
            ],
            tableConfig: [
                { 'prop': 'contractCode', 'value': '主合同编码' },
                { 'prop': 'contractName', 'value': '主合同名称' },
                { 'prop': 'validTime', 'value': '生效日期' },
                { 'prop': 'failTime', 'value': '失效日期' }
            ],
            prefix: '/api-lcrm',
            method: 'post',
            advanceUrl: `/contract/info/page`,
            cbParams: ['contractCode#mainContract'],
            beforeRequest: (params) => {
                params.contractCode = params.contractCode ? params.contractCode : null;
                params.contractName = params.contractName ? params.contractName : null;
                // params.contractCharacter = '1'; // 合同性质为新签
                params.userCode = store.getters.user.userCode;
                return params;
            }
        },
        {
            label: '选取项目/商机',
            name: '选取项目/商机',
            prop: 'projectCode',
            value: 'projectCodes',
            labelWidth: '150px',
            dialogWidth: '1200px',
            selection: true,
            type: 'custom',
            focusShowDialog: true,
            visible: true,
            multiple: true,
            border: true,
            firstNoFetch: true,
            disabledDbClick: true,
            rule: [
                { required: false, message: '项目编码不能为空', trigger: ['change', 'blur'] }
            ],
            advanceConfig: [
                { prop: 'projectCode', value: '项目编码' },
                { prop: 'opportunityCode', value: '商机编码' },
                { prop: 'opportunityName', value: '商机名称' },
                { prop: 'opportunityCustomerName', value: '客户' }
            ],
            tableConfig: [
                { prop: 'opportunityCode', value: '商机编码' },
                { prop: 'opportunityName', value: '商机名称' },
                { prop: 'projectCode', value: '项目编码' },
                { prop: 'companyName', value: '分公司' },
                { prop: 'businessCenterName', value: '经营中心' },
                { prop: 'opportunityCustomerName', value: '客户名称' },
                {
                    value: '实际中标规模(万)',
                    prop: 'totalScale'
                },
                {
                    value: '目前规模(万)',
                    prop: 'businessScale'
                },
                {
                    value: '签单规模(万)',
                    prop: 'cdExpectBiddingSize'
                },
                {
                    value: '销售阶段',
                    prop: 'saleStage',
                    type: 'select',
                    optionsKey: 'NEOCRM_SALE_STAGE'
                },
                {
                    value: '输单阶段',
                    prop: 'lostStage',
                    type: 'select',
                    optionsKey: 'NEOCRM_SALE_STAGE'
                },
                {
                    value: '报签确认',
                    prop: 'isSign',
                    type: 'select',
                    optionsKey: 'NEOCRM_YES_NO'
                },
                {
                    value: '中标日期',
                    prop: 'winningDate',
                    width: 160
                },
                {
                    value: '仓库类型',
                    prop: 'warehouseType',
                    type: 'select',
                    optionsKey: 'NEOCRM_WH_TYPE'
                },
                {
                    value: '责任人名称',
                    prop: 'ownerName'
                }
                // {
                //     prop: 'projectStatus',
                //     value: '项目状态',
                //     label: '项目状态',
                //     type: 'select',
                //     optionsKey: 'CRM_CUSTOMER_PROJECT_STATUS',
                //     options: []
                // }
            ],
            MultipleConfig: {
                NoInsertFirstConfig: true,
                method: 'post',
                // prefix: 'pms-template',
                advanceCascade: { param: {} },
                tableConfig: [
                    {
                        prop: 'opportunityCode',
                        value: '商机编码'
                    },

                    {
                        prop: 'opportunityName',
                        value: '商机名称'
                    },
                    {
                        prop: 'projectCode',
                        value: '项目编码'
                    }
                ]
            },
            otherMultiple: [{ prop: 'id' }, { prop: 'isLinkOppo' }, { prop: 'companyCode' }, { prop: 'opportunityEntityType' }],
            // searchObj: {
            //     key: 'projectCode',
            //     keyword: ''
            // },
            searchType: 'input',
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: `/opportunity/info/page`,
            cbParams: ['companyCode', 'id#opportunityId', 'id', 'opportunityCode', 'opportunityName', 'projectCode', 'opportunityCustomerName', 'companyName', 'businessCenterName',
                'totalScale', 'businessScale', 'cdExpectBiddingSize', 'saleStage', 'lostStage', 'isSign', 'winningDate', 'warehouseType', 'ownerName',
                'isLinkOppo', 'opportunityEntityType'
            ],
            confirmCb: (data, config) => {
                const overseasType = 'overseasIntroduction__c'; // 海外业务类型
                const keys = Object.keys(data);
                const values = keys.map(key => data[key].split(','));
                // 构建对象数组
                const result = values[0].map((_, index) => {
                    return keys.reduce((obj, key, i) => {
                        obj[key] = values[i][index];
                        return obj;
                    }, {});
                });
                if (result.some(it => it.opportunityEntityType === overseasType)) {
                    const overseasList = result.filter(it => it.opportunityEntityType !== overseasType)?.map(it => it.opportunityCode) || [];
                    if (overseasList.length) {
                        const tipsText = '若新建海外合同，关联商机只能为海外商机。以下商机不是海外商机，请核实。商机编码：';
                        Message.warning(tipsText + overseasList.join(','));
                        return false;
                    }
                }
                return true;
            },
            // isCheck:是否校验客户主体 projectType:报价项目类型 isLinkOppo:是否校验关联商机
            beforeRequest: async (params) => {
                await getDictList();
                params.saleStages = dictData.saleStages;
                params.orderBy = 'winning_date';
                params.orderByType = 'desc';
                return params;
            }
        }
    ],
    height: 325,
    columns: [
        {
            label: '商机编码',
            prop: 'opportunityCode',
            width: 130
        },
        {
            label: '商机名称',
            prop: 'opportunityName',
            width: 130
        },
        {
            label: '项目编码',
            prop: 'projectCode',
            width: 140
        },
        {
            label: '分公司',
            prop: 'companyName',
            width: 140
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            width: 140
        },
        {
            label: '客户名称',
            prop: 'opportunityCustomerName',
            width: 140
        },
        {
            label: '实际中标规模(万)',
            prop: 'totalScale',
            width: 120
        },
        {
            label: '目前规模(万)',
            prop: 'businessScale',
            width: 100
        },
        {
            label: '签单规模(万)',
            prop: 'cdExpectBiddingSize',
            width: 100
        },
        {
            label: '销售阶段',
            prop: 'saleStage',
            type: 'select',
            optionsKey: 'NEOCRM_SALE_STAGE'
        },
        {
            label: '输单阶段',
            prop: 'lostStage',
            type: 'select',
            optionsKey: 'NEOCRM_SALE_STAGE'
        },
        {
            label: '报签确认',
            prop: 'isSign',
            type: 'select',
            optionsKey: 'NEOCRM_YES_NO'
        },
        {
            label: '中标日期',
            prop: 'winningDate',
            width: 160
        },
        {
            label: '仓库类型',
            prop: 'warehouseType',
            type: 'select',
            optionsKey: 'NEOCRM_WH_TYPE',
            minWidth: 100
        },
        {
            label: '责任人名称',
            prop: 'ownerName'
        }
    ],
    selectable(row, index) {
        return !row.disabledBid && !row.disabled30;
    }
};
